import * as actions from '../constants/actions'
import * as formats from '../constants/formats'
import { createReducer } from '../utils/redux'
import { combineReducers } from 'redux'

const formatReducer = createReducer(formats.PDF, {

    [actions.CHANGE_EXPORT_FORMAT]: (state, action) => action.format

})

const defaultFields = {}

const fieldsReducer = createReducer(defaultFields, {

    [actions.TOGGLE_EXPORT_FIELD]: (state, action) => ({
    	...state,
    	[action.field]: !state[action.field]
    })

})

export default combineReducers({
	format: formatReducer,
	fields: fieldsReducer
})


// WEBPACK FOOTER //
// ./src/reducers/exportSettings.js